<h1>Pricing</h1>
<p>
  Licence can be granted to a league season, a tournament or an event. If you are interested in using Ball Score
  for your streams or broadcasts, contact us via e-mail cuhel&#64;ballscore.app. The price mainly depends on number of teams,
  duration of the support and target platform.
</p>
<h2>Free version</h2>
<p>
  If all you need is the status component (scoreboard), you can use Ball Score for free. You can still adjust the league
  logo and team colors, but other graphic components are now available for you.
</p>
